
import { useContext } from 'react'
import {AppContext} from "../../../contextApi/ContextApi";
import ProfileOrderCard from './ProfileOrderCard';
import "./profilePage.css";
import ProfileDetailSection from './ProfileDetailSection';

export default function ProfilePage() {
  const { currentUser, accent_color, primary_color, hasCategories } = useContext(AppContext);
  const deployOrders = ()=>{
    if(!currentUser || !currentUser.orders)return;
    if(currentUser?.orders?.length === 0){
      return <h3>עדיין לא ביצעת הזמנות</h3>
    }
    return currentUser?.orders.map((order, inx)=>{
      return <ProfileOrderCard key={`profileOrderCard_inx_${inx}`} order={order}/>
    })
  }
  return (
    <div>
      <h1 style={{margin:"75px auto 50px", color:accent_color, textShadow:`2px 2px 4px ${primary_color}`}}>איזור אישי</h1>
      <div style={{width:"80%", margin:"auto", paddingBottom:"40px",borderBottom:`0.5px solid ${accent_color}`}}>
        <h2 style={{margin:"30px auto",color:accent_color, textShadow:`2px 2px 4px ${primary_color}`}}>הפרטים האישיים שלי</h2>
        <div className='profilePage_detailsDiv'>
          <ProfileDetailSection label={"מס' פלאפון"} id={"profilePage_detailsDiv_phone"} value={currentUser?.phone} updateParam={"phone"}/>
          <ProfileDetailSection label={"אימייל"} id={"profilePage_detailsDiv_email"} value={currentUser?.email} updateParam={"email"}/>
          <ProfileDetailSection label={"שם משתמש"} id={"profilePage_detailsDiv_name"} value={currentUser?.name} updateParam={"name"}/>
          <ProfileDetailSection label={"כתובת"} id={"profilePage_detailsDiv_address"} value={currentUser?.address !== "" ? currentUser?.address : "לא הוגדרה כתובת"} updateParam={"address"}/>
        </div>
      </div>
      {hasCategories && <div style={{width:"80%", margin:"auto", paddingBottom:"40px",borderBottom:`0.5px solid ${accent_color}`}}>
        <h2 style={{margin:"30px auto",color:accent_color, textShadow:`2px 2px 4px ${primary_color}`}}>ההזמנות שלי</h2>
        <div style={{display:"flex", flexDirection:"column-reverse"}}>
          {deployOrders()}
        </div>
      </div>}
    </div>
  )
}
